import ETracker from '@fuxi/eevee-tracker';
import ETrackerPluginPv from '@fuxi/eevee-tracker-plugin-pv';
import ETrackerPluginEvent from '@fuxi/eevee-tracker-plugin-event';
import ETrackerPluginPerf from '@fuxi/eevee-tracker-plugin-perf';
import ETrackerPluginApi from '@fuxi/eevee-tracker-plugin-api';
import ETrackerPluginAutolog from '@fuxi/eevee-tracker-plugin-autolog';
import ETrackerPluginResourceError from '@fuxi/eevee-tracker-plugin-resourceerror';
import ETrackerPluginBlank from '@fuxi/eevee-tracker-plugin-blank';

// @ts-ignore
function startETracker(config) {
    const noop = () => { };
    const output = {
        switchPage: noop,
        sendPV: noop,
        sendLeave: noop,
        sendEvent: noop,
        mark: noop,
        measure: noop,
        sendApi: noop,
        sendResourceError: noop,
    };
    if (!config.plugins) {
        config.plugins = ['blank', 'pv', 'event', 'perf', 'api', 'autolog', 'resourceerror'];
    }
    ETracker.setConfig(config);
    // 若设置了enableEnv且env在enableEnv中才进行plugins的加载
    if (!config.enableEnv || (config.enableEnv && (config.enableEnv === config.env || (Array.isArray(config.enableEnv) && config.enableEnv.indexOf(config.env) > -1)))) {
        (config.plugins || []).forEach(plugin => {
            switch (plugin) {
                case 'pv':
                    const { switchPage, sendPV, sendLeave } = ETracker.use(ETrackerPluginPv);
                    Object.assign(output, { switchPage, sendPV, sendLeave });
                    break;
                case 'event':
                    const sendEvent = ETracker.use(ETrackerPluginEvent);
                    Object.assign(output, { sendEvent });
                    break;
                case 'perf':
                    const { mark, measure } = ETracker.use(ETrackerPluginPerf);
                    Object.assign(output, { mark, measure });
                    break;
                case 'api':
                    const { sendApi } = ETracker.use(ETrackerPluginApi);
                    Object.assign(output, { sendApi });
                    break;
                case 'autolog':
                    ETracker.use(ETrackerPluginAutolog);
                    break;
                case 'resourceerror':
                    const { sendResourceError } = ETracker.use(ETrackerPluginResourceError);
                    Object.assign(output, { sendResourceError });
                    break;
                case 'blank':
                    ETracker.use(ETrackerPluginBlank);
            }
        });
    }
    else {
        console.warn('[ETrackerStarter]: 注意，当前env不在enableEnv中，所有插件均未生效');
    }
    return Object.assign(output, { ETracker });
}

export { startETracker as default };
